import Component from '@cell/cell-core/component/component';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import './announcement-bar.scss';

const DESKTOP_BREAKPOINT = 769;

class AnnouncementBar extends Component {
  constructor() {
    super();

    this.swiper = null;
    this.autoplayTimeout = -1;

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    globalThis.on('resize', this.handleResize);

    if (this.shouldInitializeSlider) {
      this.initializeSwiper();

      const announcmentBarNavigationButtonElements = this.querySelectorAll(
        '[class^="swiper-button-"]',
      );

      // When interacting with the navigation arrows, stop the autoplay and restart it after 10 seconds.
      // Since `delay` is already 4000ms we just need to add a timeout of an additional 6000ms.
      announcmentBarNavigationButtonElements.forEach((announcmentBarNavigationButtonElement) => {
        announcmentBarNavigationButtonElement.addEventListener('click', () => {
          if (this.swiper) {
            this.swiper.autoplay.stop();

            this.autoplayTimeout = window.setTimeout(() => {
              this.swiper.autoplay.start();
            }, 6000);
          }
        });
      });
    }

    this.updateCSSCustomProperties();
  }

  handleResize() {
    if (this.shouldInitializeSlider) {
      if (!this.swiper) {
        this.initializeSwiper();
      }
    } else {
      if (this.swiper) {
        this.destroySwiper();
      }
    }

    this.updateCSSCustomProperties();
  }

  initializeSwiper() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      modules: [Navigation, Autoplay],
      direction: 'horizontal',
      loop: true,
      speed: 800,
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 4000,
      },
    });
  }

  destroySwiper() {
    this.swiper.destroy();
    this.swiper = null;

    window.clearTimeout(this.autoplayTimeout);
  }

  updateCSSCustomProperties() {
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${this.offsetHeight}px`,
    );
  }

  get shouldInitializeSlider() {
    return window.innerWidth < DESKTOP_BREAKPOINT && this.parsedDataset.blocksSize > 1;
  }
}

customElements.define('announcement-bar', AnnouncementBar);
